import React, { ReactNode } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';
import { isLink } from '../../utils/utils';
import { CardType } from '../../components/CardContent/logic';
import { CardContent } from '../../components/CardContent';
import { TagBlockProps } from '../../components/Tag';

import { applyCardContentStyle, applyCardStyle, applyImgStyle } from './logic';
import { ImageProps } from '../../components/Image/types';
import { CardContentImageProps } from '../../components/CardContent/CardContentImage';

export interface CardWithoutBgProps extends DefaultBsComponent {
  cardType?: CardType;
  title: string;
  subtitle?: string;
  tags?: TagBlockProps[];
  capsText?: string;
  logo?: ImageProps;
  image?: CardContentImageProps;
  imgPosition?: 'top' | 'right' | 'left' | 'none';
  ctaButton?: ReactNode;
  className?: string;
  displaySubtitleOnSmallDevice?: boolean;
  linkProps?: any;
  content?: ReactNode;
  ComponentTag?: 'div' | 'article' | 'section';
  TitleTag?: 'h3';
  ContentTag?: 'p';
  isLink?: boolean;
  onClick?: any;
}

export const CardWithoutBg = ({
  title,
  subtitle = '',
  tags,
  capsText,
  logo,
  image,
  imgPosition = 'top',
  ctaButton,
  className,
  displaySubtitleOnSmallDevice = false,
  TitleTag = 'h3',
  ContentTag = 'p',
  content,
  as: Component = 'div',
  onClick,
  ...props
}: CardWithoutBgProps) => {
  return (
    <Component
      className={classNames(
        'CardWithoutBg',
        'flex flex-col',
        applyCardStyle(imgPosition),
        isLink({ ...props }) && 'group cursor-pointer',
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {image && (
        <CardContent.Image
          {...image}
          className={classNames(
            'w-full overflow-hidden rounded-18',
            applyImgStyle(imgPosition),
          )}
          sizes={[
            '(max-width: 350px) 281px',
            '(max-width: 768px) 581px',
            '(max-width: 1024px) 712px',
            '(max-width: 1280px) 300px',
            '376px',
          ]}
        >
          {logo && (
            <div
              className={
                'absolute bottom-24 left-24 h-64 w-max rounded-6 bg-neutral-1 px-20 py-16'
              }
            >
              <CardContent.Logo
                {...logo}
                className={'max-h-full h-full w-auto max-w-full'}
                classNameImg="w-full"
                sizes={'122px'}
              />
            </div>
          )}
        </CardContent.Image>
      )}
      <div
        className={`flex flex-col-reverse ${applyCardContentStyle(
          imgPosition,
        )}`}
      >
        <CardContent
          cardType={CardType.WithoutBgCard}
          displaySubtitleOnSmallDevice={displaySubtitleOnSmallDevice}
        >
          {!image && logo && (
            <CardContent.Logo
              {...logo}
              className="max-h-[48px]"
              classNameImg="w-full object-contain object-left"
              sizes={'122px'}
            />
          )}
          {capsText && <CardContent.Caps>{capsText}</CardContent.Caps>}
          {tags && <CardContent.Tags tags={tags} />}
          {title && (
            <CardContent.Title as={TitleTag}>{title}</CardContent.Title>
          )}
          {subtitle && <CardContent.Subtitle>{subtitle}</CardContent.Subtitle>}
          {content && (
            <CardContent.Content as={ContentTag}>{content}</CardContent.Content>
          )}
          {ctaButton && <CardContent.Cta>{ctaButton}</CardContent.Cta>}
        </CardContent>
      </div>
    </Component>
  );
};
